import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    events as baseEvents,
} from '../component-base/props';
import { getFormConfig } from '../../config';
import { OCR_TYPE } from '../../const';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    {
        key: 'isOcr',
        label: '是否图像识别',
        type: 'boolean',
    },
    {
        key: 'ocrType',
        label: '图像识别类型',
        type: 'enum',
        collection: [
            {
                label: '身份证',
                value: OCR_TYPE.ID_CARD,
            },
            {
                label: '银行卡',
                value: OCR_TYPE.BANK_CARD,
            },
            {
                label: '营业执照',
                value: OCR_TYPE.BUSINESS_LICENSE,
            },
        ],
    },
    {
        key: 'ocrFail',
        label: '识别失败文案',
        type: 'string',
        props: {
            maxlength: 45,
            showWordLimit: true,
        },
    },
    {
        key: 'ocrSuccess',
        label: '识别成功文案',
        type: 'string',
        props: {
            maxlength: 45,
            showWordLimit: true,
        },
    },
    {
        key: 'hideTitle',
        label: '是否隐藏标题文字',
        type: 'boolean',
    },
    {
        key: 'showTips',
        label: '表单提示文案',
        type: 'editor',
        menuList,
    },
    {
        key: 'hint',
        label: '提示文字',
        type: 'string',
    },
    {
        key: 'errUpload',
        label: '上传错误提示文案',
        type: 'string',
    },
    {
        key: 'errNetwork',
        label: '网络错误默认提示',
        type: 'string',
    },
    {
        key: 'tipRetry',
        label: '重试按钮文案',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'min',
        label: '最少个数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMin',
        label: '最少个数提示文案',
        type: 'string',
    },
    {
        // 约定0为不处理
        key: 'max',
        label: '最大个数',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errMax',
        label: '最大个数提示文案',
        type: 'string',
    },
    {
        key: 'autoUpload',
        label: '选中文件后立即上传',
        type: 'boolean',
    },
    {
        key: 'action',
        label: '上传地址',
        type: 'string',
    },
    {
        key: 'accept',
        label: '格式限制',
        type: 'string',
        props: {
            placeholder: '如 image/* ,留空代表不限制',
        },
    },
    {
        // 约定0为不处理
        key: 'maxSize',
        label: '大小限制(kb)',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errSizeExceed',
        label: '大小超限提示',
        type: 'string',
    },
    {
        key: 'fileName',
        label: '上传时字段名',
        type: 'string',
        props: {
            placeholder: '上传文件时文件的name属性',
        },
    },
    {
        key: 'pickKey',
        label: '保留哪个返回值',
        type: 'string',
        props: {
            placeholder: '留空代表保留所有返回值',
        },
    },
    {
        key: 'previewSrc',
        label: '预览地址',
        type: 'string',
        props: {
            placeholder: '如 /a/b/c?id={file} 替换{file}为文件id',
        },
    },
    {
        key: 'exampleSettings',
        label: '示例图',
        type: 'exampleSettings',
        props: {
        },
    },
];

export const init = () => {
    const formConfig = getFormConfig();
    return {
        ...ablePropsInit,
        ...requiredPropsInit,
        isOcr: false,
        ocrFail: '识别失败！请按照提示填写以下内容',
        ocrSuccess: '识别成功！请确保识别内容是否与图片信息一致',
        hideTitle: true,
        hint: '',
        errUpload: '上传失败',
        errNetwork: '网络错误',
        tipRetry: '点击重试',
        min: 0,
        errMin: '',
        max: 0,
        errMax: '',
        autoUpload: true,
        action: formConfig.uploadActionSrc,
        accept: '',
        maxSize: 0,
        errSizeExceed: '',
        fileName: 'file',
        pickKey: 'key',
        previewSrc: formConfig.uploadPreviewSrc,
        exampleSettings: '',
    };
};

export const name = '文件上传';

export const component = 'mobile-general-form-upload';

export const events = [
    // 'length-change',
    // 'length-increase',
    // 'length-decrease',
    'all-success',
    'change',
    ...baseEvents,
];

export const menuList = [
    'undo',
    'redo',
    'heading',
    'bold',
    'link',
];
